export default __webpack_public_path__ + "static/media/top_sekorei.079f63ca.jpg";